import { notifications } from '@mantine/notifications';

type TNotification = {
  title?: string;
  message?: string;
};

export const showSuccess = (params: TNotification) => {
  const {
    title = 'Успех!',
    message = 'Операция успешно выполнена',
  } = params;

  notifications.show({
    title,
    message,
    color: 'green',
  });
};

export const showError = (params: TNotification) => {
  const {
    title = 'Ошибка!',
    message = 'Произошла ошибка',
  } = params;

  notifications.show({
    title,
    message,
    color: 'red',
  });
};
